export default {
  errorText: "Error, ",
  charCountStatus1: "out of",
  charCountStatus2: "characters entered",
  charCountStatus3: "characters over limit"
};